/**
 * Subtype of an authorities-document product, or null when the product is not an authorities
 * document — backend-computed (ISSUE-2673), read instead of `type`. The values are name-identical
 * to the legacy document ProductTypes they replace.
 */
export enum DocumentSubtype {
  MUNICIPAL = 'MUNICIPAL',
  LAW_INQUIRIES = 'LAW_INQUIRIES',
  LAND_REGISTRATION = 'LAND_REGISTRATION',
  DOCUMENTATION = 'DOCUMENTATION',
  PROTECTION = 'PROTECTION',
  CONSTRUCTION_FILE = 'CONSTRUCTION_FILE',
}
